'use client';
import { createStyles, xref } from '@s7/styles';
import { isObject } from '@s7/utils';
import { defaultStylesParams } from './defaults.js';
import { IDENT } from './TextButton.contract.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const getViewSpec = (theme, variant, color)=>{
    if (variant === 'secondary') {
        return _extends({
            default: theme.palette.text.medium
        }, theme.fn.deriveStates(theme.palette.text.medium, 'color'), {
            disabled: theme.palette.text.quaternary,
            focus: theme.palette.primary.mid
        });
    }
    const shades = theme.fn.deriveShades(theme.fn.themeColor(color));
    const mid = shades.mid || shades[200];
    const base = shades.base || shades[600];
    return _extends({
        default: base
    }, theme.fn.deriveStates(base, 'color'), {
        disabled: mid,
        focus: mid
    });
};
const xrefIcon = xref(IDENT, 'icon');
const xclassIcon = `.${xrefIcon}`;
const xrefLabel = xref(IDENT, 'label');
const xclassLabel = `.${xrefLabel}`;
const getRootStyles = (theme, { transitionDuration }, shades, xrefClass)=>{
    return _extends({}, theme.fn.focusRing({
        color: shades.focus
    }), {
        [xrefClass]: _extends({
            color: shades.default
        }, theme.fn.transition({
            fn: 'ease-in-out',
            props: [
                'color'
            ],
            duration: transitionDuration
        })),
        [`&:hover ${xrefClass}`]: {
            color: shades.hover
        },
        [`&:active ${xrefClass}`]: {
            color: shades.active
        },
        [`&:disabled,&[data-disabled=true] ${xrefClass}`]: {
            color: shades.disabled,
            pointerEvents: 'none'
        }
    });
};
const emitStyles = (theme, params)=>{
    const { typography: _typography, variant, size, color } = _extends({}, defaultStylesParams, params);
    const _ref = _typography || {}, { color: typographyColor } = _ref, typography = _object_without_properties_loose(_ref, [
        "color"
    ]);
    const shades = getViewSpec(theme, variant, color);
    const labelShades = isObject(typographyColor) || !typographyColor ? shades : getViewSpec(theme, variant, typographyColor);
    return _extends({}, theme.fn.typography(_extends({
        weight: 500,
        size
    }, typography)), getRootStyles(theme, params, shades, xclassIcon), getRootStyles(theme, params, labelShades, xclassLabel));
};
var useStyles = createStyles((theme, _param, _)=>{
    var { breakpoints } = _param, params = _object_without_properties_loose(_param, [
        "breakpoints"
    ]);
    return {
        root: _extends({
            position: 'relative',
            userSelect: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 3,
            [`&[data-loading=true] ${xclassIcon}`]: {
                pointerEvents: 'none'
            },
            '&[data-loading=true],&[data-disabled=true]': {
                pointerEvents: 'none'
            }
        }, emitStyles(theme, params), theme.fn.responsive(breakpoints)((params)=>emitStyles(theme, params))),
        label: {
            ref: xrefLabel
        },
        icon: {
            ref: xrefIcon
        },
        leftIcon: {},
        rightIcon: {}
    };
});

export { useStyles as default, getViewSpec };
//# sourceMappingURL=TextButton.styles.js.map
